/* global $:false */

/*
 * decaffeinate suggestions:
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import 'modernizr.js'
import LoginDialog from 'src/public/login_dialog.js'
import 'jquery-ui/effect-highlight.js'

export default class AbsenteeBidForm {
  static init () {
    return Array.from($('.js-absentee-form')).map((el) =>
      new AbsenteeBidForm(el))
  }

  constructor (el) {
    this.el = $(el)
    this.findElements()
    this.readDataAttributes()
    this.setupBindings()
    this.activate()
  }

  findElements () {
    this.amountField = this.el.find('.js-absentee-form__input')
    this.newBidButton = this.el.find('.js-absentee-form__new-bid-button')
    this.createBidButton = this.el.find('.js-absentee-form__create-bid-button')
    this.cancelBidButton = this.el.find('.js-absentee-form__cancel-bid-button')
    this.destroyBidLink = this.el.find('.js-absentee-form__destroy')
    this.positiveStatus = this.el.find('.js-absentee-form__positive-status')
    this.negativeStatus = this.el.find('.js-absentee-form__negative-status')
    this.noticeStatus = this.el.find('.js-absentee-form__notice-status')
    this.currentBidContainer = this.el.find('.js-absentee-form__current-bid')
    this.currentBidNone = this.el.find('.js-absentee-form__current-bid--none')
    this.currentBidExists = this.el.find('.js-absentee-form__current-bid--exists')
    this.currentBidAmount = this.el.find('.js-absentee-form__current-bid-amount')
    this.newSpinner = this.el.find('.js-absentee-form__new-spinner')
    this.createSpinner = this.el.find('.js-absentee-form__create-spinner')
    this.destroySpinner = this.el.find('.js-absentee-form__destroy-spinner')
  }

  readDataAttributes () {
    this.lotID = this.el.data('lot-id')
    this.showBidUrl = this.currentBidAmount.data('url')
    this.newBidUrl = this.newBidButton.data('url')
    this.createBidUrl = this.createBidButton.data('url')
    this.destroyBidUrl = this.destroyBidLink.data('url')
  }

  setupBindings () {
    this.newBidButton.click(() => this.new())
    this.createBidButton.click(() => this.create())
    this.cancelBidButton.click(() => this.cancel())
    this.destroyBidLink.click(event => this.destroy(event))
  }

  activate () {
    this.amountField.removeAttr('disabled')
    this.updateCurrentAmount()
    this.recallGuestBid()
  }

  updateCurrentAmount () {
    this.currentBidContainer.show()
    $.ajax(this.showBidUrl, {
      dataType: 'json',

      success: data => {
        if (data.bid_exists) {
          this.currentBidAmount.html(data.formatted_amount_with_currency)
          this.currentBidExists.show()
          this.currentBidNone.hide()
          this.destroyBidLink.show()
        } else {
          this.currentBidAmount.html('')
          this.currentBidExists.hide()
          this.currentBidNone.show()
          this.destroyBidLink.hide()
        }
      },

      error: () => {
        this.currentBidAmount.html('?')
      }
    }
    )
  }

  new () {
    if (this.amountField.val() === '') { return }
    if (!(window.gon != null ? window.gon.logged_in : undefined)) {
      this.rememberGuestBid()
      LoginDialog.show()
      return
    }

    this.newSpinner.show()
    this.lock(this.newBidButton)

    return $.ajax(this.newBidUrl, {
      dataType: 'json',
      data: {
        amount: this.amountField.val(),
        _method: 'put'
      },

      success: data => {
        this.lock(this.amountField)
        this.unlock(this.createBidButton)
        this.unlock(this.cancelBidButton)
        this.showNotice(data.message)
        this.amountField.val(data.amount)
        this.newSpinner.hide()
        this.currentBidContainer.hide()
      },

      error: request => {
        this.showNegative(request.responseJSON != null ? request.responseJSON.message : undefined)
        this.unlock(this.newBidButton)
        this.newSpinner.hide()
        this.currentBidContainer.show()
      }
    }
    )
  }

  create () {
    this.createSpinner.show()
    this.lock(this.createBidButton)
    this.lock(this.cancelBidButton)

    $.ajax(this.createBidUrl, {
      type: 'POST',
      dataType: 'json',
      data: {
        amount: this.amountField.val()
      },

      success: data => {
        this.createBidButton.hide()
        this.cancelBidButton.hide()
        this.unlock(this.newBidButton)
        this.unlock(this.amountField)
        this.amountField.val('')
        this.showPositive(data.message)
        this.createSpinner.hide()
        this.updateCurrentAmount()
      },

      error: request => {
        this.showNegative(request.responseJSON != null ? request.responseJSON.message : undefined)
        this.createBidButton.hide()
        this.cancelBidButton.hide()
        this.unlock(this.newBidButton)
        this.unlock(this.amountField)
        this.createSpinner.hide()
        this.updateCurrentAmount()
      }
    }
    )
  }

  cancel () {
    this.newBidButton.fadeTo('fast', 1)
    this.newBidButton.removeAttr('disabled')
    this.createBidButton.hide()
    this.cancelBidButton.hide()
    this.amountField.removeAttr('disabled')
    this.currentBidContainer.show()
    this.hideStatus()
  }

  destroy (event) {
    event.preventDefault()
    this.destroySpinner.show()
    $.ajax(this.destroyBidUrl, {
      type: 'POST',
      dataType: 'json',
      data: {
        amount: this.amountField.val(),
        _method: 'delete'
      },

      success: data => {
        this.showPositive(data.message)
        this.updateCurrentAmount()
        this.destroySpinner.hide()
      },

      error: request => {
        this.showNegative(request.responseJSON != null ? request.responseJSON.message : undefined)
        this.updateCurrentAmount()
        this.destroySpinner.hide()
      }
    }
    )
  }

  lock (el) {
    el.attr('disabled', 'disabled')
    if (!el.is('button')) { return }
    el.fadeTo('fast', 0.5)
  }

  unlock (el) {
    el.show()
    el.removeAttr('disabled')
    el.fadeTo('fast', 1)
  }

  showPositive (message) {
    this.hideStatus()
    this.positiveStatus.html(message)
    this.positiveStatus.show()
    this.positiveStatus.effect('highlight')
  }

  showNegative (message) {
    this.hideStatus()
    this.negativeStatus.html(message)
    this.negativeStatus.show()
    this.negativeStatus.effect('highlight')
  }

  showNotice (message) {
    this.hideStatus()
    this.noticeStatus.html(message)
    this.noticeStatus.show()
    this.noticeStatus.effect('highlight')
  }

  hideStatus () {
    this.negativeStatus.hide()
    this.positiveStatus.hide()
    this.noticeStatus.hide()
  }

  rememberGuestBid () {
    if (!window.Modernizr.localstorage) { return }
    window.localStorage.setItem(this.storageKey(), this.amountField.val())
  }

  recallGuestBid () {
    let amount
    if (!window.Modernizr.localstorage) { return }
    if (!(window.gon != null ? window.gon.logged_in : undefined)) { return }
    if (!(amount = window.localStorage.getItem(this.storageKey()))) { return }
    window.localStorage.removeItem(this.storageKey())
    this.amountField.val(amount)
  }

  storageKey () {
    return `guest_absentee_bid_lot_${this.lotID}`
  }
}
